import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || Math.abs(i - currentPage) <= 1) pages.push(i);
        else if (pages[pages.length - 1] !== '...') pages.push('...');
    }
    return (
        <div className="flex items-center justify-center gap-1 pt-4 pb-1">
            <button disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}
                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-600 disabled:opacity-30">
                <ChevronLeft size={14} />
            </button>
            {pages.map((p, i) => p === '...'
                ? <span key={i} className="px-1 text-sm text-gray-400">…</span>
                : <button key={i} onClick={() => onPageChange(p)}
                    className={`inline-flex h-8 w-8 items-center justify-center rounded-lg text-sm font-semibold transition ${p === currentPage ? 'bg-sb-primary text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
                    {p}
                </button>
            )}
            <button disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}
                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-600 disabled:opacity-30">
                <ChevronRight size={14} />
            </button>
        </div>
    );
}
